<template>
  <RouterView
    v-if="!loading && result?.ticket"
    :current-active-tab="currentActiveTab"
    :invitation-quota="props.invitationQuota"
    :is-limit-reached="isLimitReached"
    :loading="loading"
    :payment-info-error="paymentInfoError"
    :ticket="result.ticket"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useTicketQuery, type InvitationQuotaQuery } from '@/gql/myomr'

import { getCurrentActiveTab } from './activeTab'

const route = useRoute()
const currentActiveTab = getCurrentActiveTab(route)

const props = defineProps<{
  invitationQuota: InvitationQuotaQuery['invitationQuota']
  isLimitReached: boolean
}>()

const { result, loading, error } = useTicketQuery(
  { identifier: route.params.ticketId as string },
  { fetchPolicy: 'network-only', errorPolicy: 'all' },
)

const paymentInfoError = computed(
  () => error.value?.graphQLErrors?.find((e) => e.extensions?.code === 'INVALID_PERMISSIONS' && e.path?.includes('paymentInfo'))?.message,
)
</script>
